import React          from 'react'
import Dashboard      from './dashboard'
import DashboardTable from './dashboard_table'
const DashboardRenderer = ({
  datatableLoading,
  currentDashboard,
  setCurrentDashboard,
  availableWidgetDefinitions,
  columns,
  rows,
  dashboardView,
  setDatatableLoading,
  exportTitle,
  encoding,
  userCanRead
}) => {
  if (datatableLoading) {
    return (
      <div className = "loading">
        <div className = "dot-elastic"></div>
      </div>
    )
  }

  return(
    <>
      {!dashboardView && (
        <DashboardTable 
          rows                = {rows} 
          columns             = {columns} 
          setDatatableLoading = {setDatatableLoading}
          exportTitle         = {exportTitle}
          encoding            = {encoding}
        />
      )}

      {userCanRead && dashboardView && (
        <Dashboard 
          rows                       = {rows} 
          currentDashboard           = {currentDashboard}
          setCurrentDashboard        = {setCurrentDashboard}
          availableWidgetDefinitions = {availableWidgetDefinitions}
          dashboardView              = {dashboardView}
        />
      )}
    </>
  )
}

export default DashboardRenderer